export default {
  blank: () => import("/opt/buildhome/repo/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  home: () => import("/opt/buildhome/repo/layouts/home.vue").then(m => m.default || m)
}